"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var module_util_1 = require("../../utils/module.util");
var bff_1 = require("./bff");
var jericho_1 = require("./jericho");
var removeItem = function (cartId, removeItems) {
    throw new Error('Function not yet implemented.');
};
var replaceItem = function (cartId, removeItems, addItems) {
    throw new Error('Function not yet implemented.');
};
var updateItemQuantity = function (cartId, updateItems) {
    throw new Error('Function not yet implemented.');
};
var cartAPI = (0, module_util_1.getModules)({
    addItem: {
        jerichoFn: jericho_1.addItem_jericho,
        bffFn: bff_1.addItemToCart_bff,
    },
    addItemsAndPromos: {
        jerichoFn: function () {
            throw new Error('Function not yet implemented.');
        },
        bffFn: bff_1.addItemsAndPromosToCart_bff,
    },
    removeItem: {
        jerichoFn: removeItem,
    },
    replaceItem: {
        jerichoFn: replaceItem,
    },
    updateItemQuantity: {
        jerichoFn: updateItemQuantity,
    },
    updateCart: {
        jerichoFn: jericho_1.updateCart_jericho,
        bffFn: bff_1.updateCart_bff,
    },
});
exports.default = cartAPI;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/cartAPI/index.js
// module id = 3383
// module chunks = 11